function secondaryNavigation() {

    let smoothLinks = (function attachScrollToClickEvent() {
    let mobileLinks = document.getElementsByClassName("navigation-in-page__link");
    let desktopLinks = document.getElementsByClassName(
        "navigation-secondary-link"
    );
    
    let allLinks = [...mobileLinks, ...desktopLinks];
    
    let prevRatio = 0;
    var vh = document.documentElement.clientHeight;
    var topMargin = Math.ceil(-0.45 * vh);
    var botMargin = Math.ceil(-0.55 * vh);
    
    for (let el of allLinks) {
        let link = el.getElementsByTagName("a")[0];
        let id = link.href.split("#")[1];
        link.onclick = function scrollSectionIntoView(e) {
            let mobileLinks2 = document.getElementsByClassName("navigation-in-page__link");
            let desktopLinks2 = document.getElementsByClassName(
                "navigation-secondary-link"
            );
            let allLinks2 = [...mobileLinks2, ...desktopLinks2];
            for (let el2 of allLinks2) {
                let link2 = el2.getElementsByTagName("a")[0];
                link2.classList.remove("is-active");
            }
            this.classList.add("is-active");
            document.getElementById(id).scrollIntoView({ behavior: "smooth" });
            const options = {
                action: 'close'
            }
            window && window.toggleMenu(options);
        
            // Lets add a # to the browser URL
            // window.setTimeout(function updateHashAfterScroll() {
            //   window.location.hash = `#${id}`;
            // }, 500);
        
            e.preventDefault();
        };
        
        // IntersectionObserver to highlight the secondary nav as we scroll past it
        // function linkObserver() {
        //     let observer;
        
        //     let options = {
        //         root: null,
        //         rootMargin: topMargin + "px 0px " + botMargin + "px",
        //         threshold: [0.25, 0.75]
        //     };
        
        //     observer = new IntersectionObserver(handleIntersect, options);
        //     observer.observe(document.getElementById(id));
        // }
    
        // function handleIntersect(entries, observer) {
        //     entries.forEach(entry => {
        //         if (entry.intersectionRatio > prevRatio) {
        //         link.style.color = "green";
        //         } else {
        //         link.style.color = "red";
        //         }
        //         prevRatio = entry.intersectionRatio;
        //     });
        // }
        // linkObserver();
    }
    })();
    
    // Lets handle the secondary nav for mobile
    var mobileSecMenu = document.getElementById("navigation-in-page__title-bar");
    if (mobileSecMenu) {

        window.toggleMenu = (function toggleMenu() {
            let menu = document.getElementById("navigation-in-page-menu");
            let toggleInitialized = false;
            
            if (menu) {
                if (!toggleInitialized) {
                menu.classList.add("is-closed");
                toggleInitialized = true;
                }
                return function toggleMenu(options = { action: "toggle" }) {
                switch (options.action) {
                    case "toggle":
                    menu.classList.contains("is-closed")
                        ? menu.classList.remove("is-closed")
                        : menu.classList.add("is-closed");
                    break;
                    case "open":
                    menu.classList.remove("is-closed");
                    break;
                    case "close":
                    menu.classList.add("is-closed");
                    break;
                }
                };
            } else {
                // throw "No in-page menu in HTML.";
            }
        })();
        
        function attachToggleToClickEvent(el) {
            el.onclick = function(event) {
                event.preventDefault();
                window.toggleMenu && window.toggleMenu();
            };
        }

        attachToggleToClickEvent(mobileSecMenu);
    }

}

export default secondaryNavigation;